import { environment } from '@core/environment';
import { GrpcRestFetchTransport, useAuth0Interceptor } from '@deepup/api-utils';
import {
  inetworkApiV1 as inetworkApi,
  inetworkClientApiV1 as inetworkClientApi,
} from '@deepup/internal-apis';
import { useMemo } from 'react';

const useInetworkClient = () => {
  const authInterceptor = useAuth0Interceptor();
  return useMemo(() => {
    const transportRest = new GrpcRestFetchTransport({
      baseUrl: environment.unifiedApiUrl,
      fetchInit: {
        credentials: 'include',
      },
      interceptors: [authInterceptor],
    });

    return new inetworkClientApi.InternalNetworkServiceClient(transportRest);
  }, [authInterceptor]);
};

export const useCreateFittingPointElement = () => {
  const client = useInetworkClient();
  const createFittingPointElement = async (input: inetworkApi.CreateFittingPointElementRequest) => {
    const res = await client.createFittingPointElement(input).response;

    return res;
  };

  return { createFittingPointElement };
};

export const useUpdateFittingPointElement = () => {
  const client = useInetworkClient();

  const updateFittingPointElement = async (input: inetworkApi.UpdatePointElementRequest) => {
    const res = await client.updatePointElement(input).response;

    return res;
  };

  return { updateFittingPointElement };
};
